<template>
	<div>
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<h4>基本信息</h4>
			</div>
			<el-descriptions title="" :column="1" border>
				<el-descriptions-item label="管理员名称">{{$route.query.admin_name}}</el-descriptions-item>
				<el-descriptions-item label="一级菜单">{{detailObject.menu}}</el-descriptions-item>
				<el-descriptions-item label="二级菜单">{{detailObject.sub_menu}}</el-descriptions-item>
				<el-descriptions-item label="操作内容">{{detailObject.explain}}</el-descriptions-item>
				<el-descriptions-item label="具体操作数据">{{detailObject.name}}</el-descriptions-item>
			</el-descriptions>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<h4>修改数据</h4>
			</div>
			<h4>原数据内容</h4>
			<el-descriptions style="margin-top: 20px;" title="" :column="1" border>
				<el-descriptions-item :labelClassName='labelClassName' v-if="detailObject.old_content"
					v-for="(item,key,index) in detailObject.old_content" :label="key">{{item}}</el-descriptions-item>
			</el-descriptions>
			<h4 style="margin-top: 30px;">新数据内容</h4>
			<el-descriptions style="margin-top: 20px;" title="" :column="1" border>
				<el-descriptions-item :labelClassName='labelClassName' v-if="detailObject.new_content"
					v-for="(item,key,index) in detailObject.new_content" :label="key">{{item}}</el-descriptions-item>
			</el-descriptions>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;" class="flex flex-c">
			<el-button type="primary" style="width: 200px;" plain @click="goBack">返回</el-button>
		</el-card>


	</div>
</template>

<script>
	import {
		imgDomain
	} from '@/configs/env';
	import operations from "@/mixins/operations";
	import CommonPagination from "@/components/CommonPagination";
	import {
		getUser,
		getAdminLogDetail,
		getAiApplicationHistoryList
	} from "@/api/auth"
	import {
		mapState
	} from "vuex";

	export default {
		name: "userDetail",
		mixins: [operations],
		data() {
			return {
				radio: '1',
				activeTab: 'first',
				imgDomain,
				total: 0,
				page_size: 9,
				page_index: 1,
				doubaoList: [],
				num: 1,
				detailObject: {},
				detailUserId: '',
				selectedTabIndex: "all",
				activeName: '1',
				user_uuid: '',
				total1: 0,
				page_index1: 1,
				page_size1: 9,
				hisLists: [],
				labelClassName: 'labelClassName'
			};
		},
		components: {
			CommonPagination,
		},
		async mounted() {
			const uuid = this.$route.query.uuid
			this.user_uuid = uuid
			this.getAdminLogDetail()
		},
		methods: {
			async getAdminLogDetail() {
				const {
					status,
					data
				} = await getAdminLogDetail({
					uuid: this.$route.query.uuid
				});
				if (status !== 200) return;
				this.detailObject = data.result
			},
			goBack() {
				this.$router.go(-1)
			},
			handleClickBack() {
				this.$router.back(-1);
			},
			async disableUser() {
				let postData = {
					user_id: this.detailObject.user_id
				}
				const {
					status,
					data
				} = await disableUser(postData);
				if (status !== 200) return;
				await this._getUserListDetail(this.detailObject.user_id);
			},

			async ableUser() {
				let postData = {
					user_id: this.detailObject.user_id
				}
				const {
					status,
					data
				} = await ableUser(postData);
				if (status !== 200) return;
				await this._getUserListDetail(this.detailObject.user_id);
			},

		}
	};
</script>

<style lang="less" scoped>
	.titles {
		color: #000;
		font-size: 20px;
	}

	.subtitle {
		color: #000;
		font-size: 18px;
		margin-bottom: 30px;
	}

	::v-deep .labelClassName {
		white-space: nowrap !important;
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.leftbg {
		display: flex;
		align-items: center;
	}

	.ava {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		margin-right: 30px;
	}

	.lefttitle {
		font-size: 16px;
		color: #999;
		margin-bottom: 20px;
	}

	.leftval {
		margin-bottom: 20px;
		font-size: 16px;
		color: #000;
	}

	.imgsList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.imgItem {
			width: 32%;
			margin-right: 20px;
			margin-bottom: 20px;
		}
	}

	.operation-item {
		color: #409EFF;
		cursor: pointer;
		justify-content: center;
	}
</style>